import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "tickets-filter__filter-values" }
const _hoisted_2 = ["id", "value", "onChange"]
const _hoisted_3 = ["for"]

import DsChip from "@sazka/design-system/src/chip/ds-chip.vue";
import { checkedFilters, useTicketsFilterHelper } from "@/tickets/components/tickets-filter/tickets-filter-state";


export default /*@__PURE__*/_defineComponent({
  __name: 'tickets-filter-filter-menu',
  props: {
    filterValues: {}
  },
  setup(__props: any) {



const { addFilter, removeFilter } = useTicketsFilterHelper();

const toggleFilter = (value: number) => {
    if (checkedFilters.value.includes(value)) {
        removeFilter(value);
    } else {
        addFilter(value);
    }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterValues, (value) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "tickets-filter__checkbox-wrapper",
        key: value
      }, [
        _createElementVNode("input", {
          type: "checkbox",
          id: `filter${value}`,
          value: value,
          onChange: ($event: any) => (toggleFilter(value)),
          class: "tickets-filter__checkbox"
        }, null, 40, _hoisted_2),
        _createElementVNode("label", {
          for: `filter${value}`,
          class: "tickets-filter__label"
        }, [
          _createVNode(DsChip, {
            tag: "span",
            type: "filter",
            "is-active": _unref(checkedFilters).includes(value),
            class: "tickets-filter__chip"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(value) + " Kč ", 1)
            ]),
            _: 2
          }, 1032, ["is-active"])
        ], 8, _hoisted_3)
      ]))
    }), 128))
  ]))
}
}

})